import hero from "../images/volunteer_hero.png";
import sc_logo_desk from "../images/logo_home_mobile.png";
import Navbar from "../sections/Navbar.js";
import volunteer_intro from "../images/volunteer_intro.png";
import maternity_mates_hero from "../images/volunteer_maternity_mates.png";
import peer_support_hero from "../images/volunteer_peerSupport.png";
import mm_personal_hero from "../images/volunteer_mm_personal.png";
import mm_professional_hero from "../images/volunteer_mm_professional.png";
import mm_experience_hero from "../images/volunteer_mm_experience.png";
import mm_apply_hero from "../images/volunteer_mm_apply.png";
import Footer from "../sections/Footer.js";
import { useRef, useState, useCallback } from "react";
import YouTubeVideo from "../components/YouTubeVideo";
import useScrollToSection from "../hooks/useScrollToSection";
import SectionReveal from "../components/SectionReveal";

// ── Toggle: set to true for scroll-triggered fade-up on content sections ──
const showSectionReveal = true;
const Volunteer = () => {
  const volunteerPageRef = useRef();
  const maternityMatesRef = useRef();
  const peerSupportRef = useRef();
  const counsellingRef = useRef();

  // Track navbar overlay state for logo z-index toggle
  const [isNavOverlayActive, setIsNavOverlayActive] = useState(false);
  const handleOverlayActive = useCallback((active) => {
    setIsNavOverlayActive(active);
  }, []);

  // Use custom hook to handle URL-based scrolling to sections
  useScrollToSection({
    "volunteer": volunteerPageRef,
    "maternity-mates": maternityMatesRef,
    "peer-support": peerSupportRef,
    "counselling": counsellingRef
  });

  return (
    <div>
      <Navbar whichRef={volunteerPageRef} currentPage="volunteer-with-us" onOverlayActive={handleOverlayActive} />
      {/* Hero */}
      <div className=" bg-[#DCB1FA]">
        <div className="mx-auto max-w-[1240px]">
          <a href="/" className="0">
            <img
              src={sc_logo_desk}
              className={`xs:mt-6  md:ml-6 s:ml-12 xs:ml-8  responsive-home-logo-width md:w-[100px] sm:w-[110px] ss:w-[110px] s:w-[100px] xs:w-[90px] absolute top-0 ${isNavOverlayActive ? '' : 'z-[22]'}`}
              alt="sister-circle-logo"
            />
          </a>
          <div className="flex  md:flex-row items-center w-full bg-[#DCB1FA] overflow-hidden">
            <div className="max-w-[1240px]  absolute md:mb-0 md:mt-0 w-[100%] ">
              <h1 className="xs:z-10 xs:relative md:static md:ml-0 xs:text-left md:text-center xs:mb-0  xs:mr-0  xs:ml-[2rem] s:ml-[3rem] sm:ml-[4rem]  md:mt-0  font-sans antialiased mds:text-[4.8rem] mds:leading-[2.2rem] s:text-[3rem] xss:text-[2.8rem] xss:leading-[2.2rem] align-middle text-[#b24029]">
                Volunteer with&nbsp;us
              </h1>
            
            </div>
            {/* --------------------------------------------------------------------------------------------------------- */}

            <div className=" md:mt-0  md:mb-0 w-[100%]  ">
              <img
                src={hero}
                className=" xs:relative md:static ss:left-[20%] xs:left-[15%] md:left-0  xs:mx-auto md:min-h-[388px] md:max-h-[100vh] ss:h-[100%] xs:h-[188px] ss:mt-0 xs:mt-[18%] hero-img float-right"
                alt="hero"
              />
            </div>
          </div>
        </div>
      </div>

      {/* ---------------------------------------------------------------------------------------------------------------
      --------------------------------------- VOLUNTEER INTRO --------------------------------------------------------
       --------------------------------------------------------------------------------------------------------- */}
      <div ref={volunteerPageRef}  className="bg-[#ffe1d9]">
        <div className="mx-auto max-w-[1240px] responsive-maternity-pt">
          <SectionReveal enabled={showSectionReveal}>
          <div className="flex xs:flex-col-reverse xs:items-center md:items-start md:flex-row w-full bg-[#ffe1d9]  overflow-hidden">
            <div className="   xs:mb-[0vh] xs:mt-10 md:mt-0  md:mb-0 xs:w-[95%] md:w-[40%] md:ml-0 xs:ml-[5%]">
              <img
                src={volunteer_intro}
                className=" xs:mx-auto max-h-[671px] block "
                alt="volunteer intro"
              />
            </div>
            {/* --------------------------------------------------------------------------------------------------------- */}
            <div className=" xs:mb-[0vh] xs:mt-0 md:mt-0  md:mb-0  xs:w-4/5 md:w-[58%] x1270:mx-[1.5rem] md:mr-[1.5rem]">
              <p className="module-subhead w-[95%] mt-0">
                Volunteers are at the heart of what we&nbsp;do. Your contribution can make an enormous difference to the lives of women who find themselves in challenging circumstances.
                <br></br><br></br>
                When women support other women, transformation happens.
              </p>
            </div>
          </div>
          </SectionReveal>
        </div>
      </div>

        {/* ---------------------------------------------------------------------------------------------------------------
      --------------------------------------- Maternity Mates ---------------------------------------------
      ----------------------------------------------------------------------------------------------------------------- */}
      <div ref={maternityMatesRef} className="bg-[#ffe1d9]">
    <div className="mx-auto max-w-[1240px] responsive-maternity-pt">
      <SectionReveal enabled={showSectionReveal}>
      <div className="flex xs:flex-col md:flex-row xs:items-center md:items-start w-full bg-[#ffe1d9] overflow-hidden">
        <div className=" module-left xs:mb-[0vh] xs:mt-[0vh] md:mt-0 md:mb-0 xs:w-4/5 md:w-[60%]">
        
          <h1 className="module-headlineL w-[100%]">
            Maternity Mates
          </h1>
          <p className="module-bodycopyL w-[100%]">
         
            Sister Circle recruits female volunteers that are compassionate, good at listening, and eager to provide emotional and practical support during pregnancy, childbirth, and the early weeks of family life. The women we support are facing challenging and complex situations, either because they are isolated, without support from family or friends, lack English language skills, are not familiar with the health system, have mild mental health issues, are migrant (e.g. asylum seekers or refugees), or are survivors of gender violence.
          </p>

          {/*--------------------- Personal benefits ---------------------------------------------- */}
          <h2 className="module-subheadL md:w-[80%] xs:w-[100%] mt-14">
            Personal benefits of becoming a&nbsp;Maternity&nbsp;Mate
          </h2>
          <p className="module-bodycopyL w-[100%] ">
            <ol className="list-disc pl-4">
              <li className="pb-3">Experience deep personal growth by supporting women facing real challenges, one&#8209;to&#8209;one.</li>
              <li className="pb-3">Feel immense satisfaction as you watch a mother's confidence grow, isolation fade, and hope blossom for her&nbsp;baby.</li>
              <li className="pb-3">Join a movement to improve maternal care in your own community.</li>
              <li className="pb-3">Become part of Sister Circle's supportive network of like-minded women.</li>
              <li className="pb-3">Take on the unique, rewarding role of birth partner—sharing one of life's most profound moments.</li>
              <li className="pb-0">Help highlight the importance of continuity of care to tackle inequalities in maternity services.</li>
            </ol>
          </p>
        </div>
        {/* --------------------------------------------------------------------------------------------------------- */}
        <div className=" md:mr-0 md:mb-[0vh] md:mt-[0vh] xs:mb-[0vh] xs:mt-10 xs:w-[95%] md:w-[40%] xs:ml-[5%] md:ml-0">
          <img
            src={maternity_mates_hero}
            className=" xs:mx-auto max-h-[671px] "
            alt="hero"
          />
        </div>
      </div>
      </SectionReveal>
    </div>
      </div>

      {/* ---------------------------------------------------------------------------------------------------------------
      --------------------------------------- Quote Section  -----------------------------------------------------------
       --------------------------------------------------------------------------------------------------------- */}
      <div className="bg-[#ffe1d9]">
        <div className="mx-auto max-w-[1240px] xs:w-4/5 md:w-full md:px-[1.5rem] min-[1270px]:pl-[4.5rem] xs:pt-[3rem] md:pt-[3rem] xs:pb-[0rem] md:pb-[0rem]">
          <SectionReveal enabled={showSectionReveal}>
          <p className="module-quote">
            <span className="module-quote-highlight">
              &ldquo;It&rsquo;s been really rewarding &ndash; I felt like I was doing something that truly mattered.&rdquo;
            </span>
          </p>
          <div className="xs:mt-6 md:mt-8">
            <span className="text-[#b24029] text-[1.5rem] leading-none">—</span>
            <p className="module-bodycopy w-[95%] ml-0 mt-0" style={{ fontSize: 'clamp(22px, calc(16.86px + 0.669vw), 26px)', lineHeight: 'clamp(26.4px, calc(20.23px + 0.803vw), 31.2px)' }}>
              Volunteer
            </p>
          </div>
          </SectionReveal>
        </div>
      </div>

      {/* ---------------------------------------------------------------------------------------------------------------
      --------------------------------------- Professional benefits --------------------------------------------------------
      ----------------------------------------------------------------------------------------------------------------- */}
       <div  className="bg-[#ffe1d9] pb-10">
        <div className="mx-auto max-w-[1240px] pt-14">
          <SectionReveal enabled={showSectionReveal}>
          <div className="flex xs:flex-col-reverse xs:items-center md:items-start md:flex-row w-full bg-[#ffe1d9] overflow-hidden">
            <div className="   xs:mb-[0vh] xs:mt-10 md:mt-0  md:mb-0 xs:w-[95%] md:w-[40%] md:ml-0 xs:ml-[5%]">
              <img
                src={mm_personal_hero}
                className=" xs:mx-auto max-h-[671px] block "
                alt="professional benefits"
              />
            </div>
            <div className=" xs:mb-[0vh] xs:mt-0 md:mt-0  md:mb-0  xs:w-4/5 md:w-[58%] x1270:mx-[1.5rem] md:mr-[1.5rem]">
              <h2 className="module-subhead md:w-[80%] xs:w-[100%] mt-0">
                Professional benefits of becoming a&nbsp;Maternity&nbsp;Mate
              </h2>
              <p className="module-bodycopy w-[95%]">
                <ol className="list-disc pl-4">
                  <li className="pb-3">
                    Receive free expert training from midwives, breastfeeding counsellors, and advocacy mentors.
                  </li>
                  <li className="pb-3">
                    Earn an accredited Level 3 qualification with nine credits from the Open College Network (OCN).
                  </li>
                  <li className="pb-3">
                    Develop valuable skills in coaching, communication, and relationship-building.
                  </li>
                  <li className="pb-3">
                    Gain practical knowledge about pregnancy, birth, and infant feeding to advance your healthcare career.
                  </li>
                  <li className="pb-3">
                    Connect with professionals across healthcare and social care sectors.
                  </li>
                  <li className="pb-0">
                    Receive references to support your future career in healthcare, social services, or community work.
                  </li>
                </ol>
              </p>
            </div>
          </div>
          </SectionReveal>
        </div>
      </div>
      {/* ---------------------------------------------------------------------------------------------------------------
    --------------------------------------------------------- video section and text ---------------------------
      --------------------------------------------------------------------------------------------------------------- */}
      <div className="bg-[#FF794E] ">
        <div className="mx-auto max-w-[1240px] md:py-[2.5rem] ">
          <SectionReveal enabled={showSectionReveal}>
          <div className="flex xs:flex-col-reverse md:flex-row xs:items-center md:items-stretch w-full bg-[#FF794E] overflow-hidden">
            <div className=" flex flex-col justify-end xs:mb-[2vh] xs:mt-0 md:mt-0  md:mb-0  xs:w-4/5 md:w-6/12">
          
              <p className="module-bodycopy module-left text-[#ffffff] mt-0 pt-0">
               Click play to listen to Maternity Mate Volunteer, Christine Lloyd-Jones, LIVE on BBC Radio London to mark Volunteers Week 2025.
              </p>

         
            </div>
            {/* --------------------------------------------------------------------------------------------------------- */}
            <div className="md:mr-0 md:mb-[0vh] md:mt-[0vh] xs:mb-10 xs:mt-[3vh] xs:w-[90%] md:w-6/12 xs:ml-[0%] md:ml-0">
              <YouTubeVideo
                videoId="qwz1QK-_mvA"
                thumbnail={mm_professional_hero}
                title="The joy of volunteering"
                className="max-h-[671px]"
              />
             
            </div>
          </div>
          </SectionReveal>
        </div>
      </div>
      {/* ---------------------------------------------------------------------------------------------------------------
      Do I need experience?
      --------------------------------------------------------------------------------------------------------------- */}
    <div className="bg-[#ffe1d9]">
      <div className="mx-auto max-w-[1240px] pt-14">
        <SectionReveal enabled={showSectionReveal}>
        <div className="flex xs:flex-col md:flex-row xs:items-center md:items-start w-full bg-[#ffe1d9] overflow-hidden">
          <div className=" module-left xs:mb-[0vh] xs:mt-[0vh] md:mt-0 md:mb-0 xs:w-4/5 md:w-[60%]">
            <h2 className="module-subheadL mt-0">
                Do I need experience?
            </h2>
            <p className="module-bodycopyL w-[100%]">
              No. All Maternity Mates benefit from a free, group training programme held once a week for five weeks using a blended delivery approach of in‑person and online sessions.<br/><br/>
              The training is accredited to Level 3 with the Open College Network (OCN) and provides the knowledge and skills needed to fulfil the role of Maternity Mate. Sessions cover various topics including antenatal care, preparing for birth, birth and postnatal support, mentoring and advocacy, infant feeding and maternal mental health. Training is delivered by professional experts, midwives, breastfeeding counsellors, and mentoring and advocacy experts.
            </p>

            {/* Mobile-only image: shown below 768px, hidden on desktop */}
            {/* Break out of parent text column (80%) to match mm_personal_hero (95% of container, 5% ml) */}
            <div className="md:hidden xs:mt-10 xs:mb-0 w-[118.75%] ml-[-6%]">
              <img
                src={mm_experience_hero}
                className="xs:mx-auto max-h-[671px] block"
                alt="Do I need experience hero"
              />
            </div>

             {/* -------------------------------------------------------------------------------------------------
                What's the commitment?
                --------------------------------------------------------------------------------------------------- */}
            <h2 className="module-subheadL md:w-[80%] xs:w-[100%] mt-14">
                What’s the commitment?
            </h2>
            <p className="module-bodycopyL w-[100%] ">
              The role is flexible. On average, Maternity Mates support three to four women over a 12‑month period. Each woman’s needs vary, but you can expect to commit around one to two hours per week of your free time.
            </p>
            {/*--------------------- How to apply---------------------------------------------- */}
            <h2 className="module-subheadL md:w-[80%] xs:w-[100%] mt-14">
              How to apply
            </h2>
            <p className="module-bodycopyL w-[100%] ">
              To apply to become a Maternity Mate, fill in this confidential form and we will be in touch soon!
            </p>
            {/* Call-to-Action Box */}
            <div className="bg-[#b24029] xs:mb-[0vh] xs:pr-4 xs:pl-7 md:px-0 m pt-10 pb-[4rem] xs:mt-10 md:mt-10  md:mb-0  ctabox-width  rounded-full rounded-l-lg max-w-[500px]">
              <p className="ctabox-circle xs:w-[70%] md:w-[60%] mds:w-[70%]   xs:mt-0 xs:mr-0 xs:ml-0 md:mt-0 md:mr-6 md:ml-7  font-sans antialiased  tracking-[-0.01em] align-middle text-[#ffe1d9]">
              </p>
              <button className="ctabox-button2">
              {/* <button className="mt-6 mb-6 xs:mr-0 xs:ml-0  md:mr-0 md:ml-7 block px-5 py-[0.4rem] s:text-base xs:text-xs font-medium text-center text-[#F7E1DA] border-2 border-[#F7E1DA] rounded-full"> */}
                <a
                  href="https://sistercirclelondon.typeform.com/to/yWNnZcXx"
                  rel="noreferrer"
                  target="_blank"
                >
                  Become a Maternity Mate
                </a>
              </button>
              <p className=" ctabox-circle  xs:mt-0 xs:mr-0 xs:ml-0 md:mt-0 md:mr-6 md:ml-7  font-sans antialiased  tracking-[-0.01em] align-middle text-[#ffe1d9]">
                Email: <span>
                  <a
                    className="underline"
                    href="mailto:volunteering@sistercircle.org.uk"
                    rel="noreferrer"
                    target="_blank"
                  >
                    volunteering@sistercircle.org.uk
                  </a>
                </span>
                
                <br></br>
                <span>or call </span>
                <span>
                  <a className="underline" href="tel:07496 531895">
                    07496 531895
                  </a>
                </span>
              </p>
            </div>
            {/*--------------------- Find out More---------------------------------------------- */}
             <h2 className="module-subheadL md:w-[80%] xs:w-[100%] mt-14">
                Find out More
            </h2>
            <p className="module-bodycopyL w-[100%] ">
              Click on the links to access more information about this opportunity.<br/><br/>
              <ol className="list-disc pl-4">
              <li className="pb-3"><a  className="underline" href="/uploads/application-template" rel="noreferrer" target="_blank">Application template (for reference)</a> </li>
              <li className="pb-3"><a className="underline" href="/uploads/volunteer-information-faq" rel="noreferrer" target="_blank">Volunteer information and FAQs</a></li>
              <li className="pb-3"><a className="underline" href="/uploads/role-description" rel="noreferrer" target="_blank">Role description</a></li>
              <li className="pb-3"><a className="underline" href="/uploads/training-schedule-east-london" rel="noreferrer" target="_blank">Training schedule East London</a></li>
              <li className="pb-0"><a className="underline" href="/uploads/training-schedule-croydon" rel="noreferrer" target="_blank">Training schedule Croydon</a></li>
            </ol>
            </p>
          </div>
          {/* --------------------------------------------------------------------------------------------------------- */}
          <div className="xs:hidden md:block md:mr-0 md:mb-[0vh] md:mt-[0vh] md:w-[40%] md:ml-0">
            <img
              src={mm_experience_hero}
              className=" xs:mx-auto max-h-[671px] "
              alt="hero"
            />
          </div>
        </div>
        </SectionReveal>
      </div>
    </div>

       {/* ----------------------------------------------------------------------------------------------------
      --------------------------------------- Peer Support Volunteer  ------------------------------------------
       --------------------------------------------------------------------------------------------------------- */}
      <div ref={peerSupportRef}  className="bg-[#ffe1d9]">
        <div className="mx-auto max-w-[1240px] responsive-maternity-pt">
          <SectionReveal enabled={showSectionReveal}>
          <div className="flex xs:flex-col-reverse xs:items-center md:items-start md:flex-row w-full bg-[#ffe1d9]  overflow-hidden">
            <div className="   xs:mb-[0vh] xs:mt-10 md:mt-0  md:mb-0 xs:w-[95%] md:w-[40%] md:ml-0 xs:ml-[5%]">
              <img
                src={peer_support_hero}
                className=" xs:mx-auto md:max-h-[671px] xs:max-h-[785px] md:max-w-[100%] block "
                alt="peer support hero"
              />
            </div>
            {/* --------------------------------------------------------------------------------------------------------- */}
             <div className="  xs:mb-[0vh]  md:mt-0  md:mb-0  xs:w-4/5 md:w-[58%] x1270:mx-[1.5rem] md:mr-[1.5rem]">
                <h1 className="module-headline  w-[95%]">
                Peer Support Volunteer
              </h1>
               <p className="module-bodycopy  w-[95%]">
                It is hard to comprehend how difficult it is to be unsupported during pregnancy and at birth, let alone during a traumatic birthing experience or at a time of tragic loss. Sadly, many women have gone through this with little or no support.<br/><br/>
                Sister Circle is looking for compassionate women with lived experience of pregnancy loss, baby loss or birth trauma who feel able to gently share their stories in group settings, helping others feel less alone.<br/><br/>
                Our peer support groups offer a safe, nurturing space for women experiencing mental health challenges linked to loss or trauma. In partnership with East London NHS Foundation Trust, we deliver groups for women using the OCEAN Maternal Mental Health Service in Tower Hamlets, Newham and Waltham Forest.
              </p>
            </div>
          </div>
          </SectionReveal>
        </div>
      </div>

      {/* ---------------------------------------------------------------------------------------------------------------
      --------------------------------------- Quote Section  -----------------------------------------------------------
       --------------------------------------------------------------------------------------------------------- */}
      <div className="bg-[#ffe1d9]">
        <div className="  mx-auto max-w-[1240px]  xs:w-4/5 md:w-full md:px-[1.5rem] min-[1270px]:pl-[4.5rem]  xs:pt-[3rem]  md:pt-[3rem] ">
          <SectionReveal enabled={showSectionReveal}>
          <p className="module-quote">
            <span className="module-quote-highlight">
              &ldquo;One day you will tell your story of how you overcame what you went through, and it will be someone else&#8217;s survival&nbsp;guide&rdquo;
            </span>
          </p>
          <div className="xs:mt-6 md:mt-8">
            <span className="text-[#b24029] text-[1.5rem] leading-none">—</span>
            <p className="module-bodycopy  w-[95%] ml-0 mt-0" style={{ fontSize: 'clamp(22px, calc(16.86px + 0.669vw), 26px)', lineHeight: 'clamp(26.4px, calc(20.23px + 0.803vw), 31.2px)' }}>
              Bren&eacute; Brown – world-renowned research professor whose work focuses on the study of courage, vulnerability, shame, and empathy.
              
            </p>
             {/* <p className="module-bodycopy  xs:w-[95%] md:w-[65%] ml-0 md:mt-10 xs:mt-14">
              Our peer support groups offer a safe, nurturing space for women experiencing mental health challenges linked to loss or trauma. In partnership with East London NHS Foundation Trust, we deliver groups for women using the OCEAN Maternal Mental Health Service in Tower Hamlets, Newham and Waltham Forest.
            </p> */}
          </div>
          </SectionReveal>
        </div>
      </div>
        {/* ---------------------------------- Do I need experience? ---------------------------------------------------- */}
       <div  className="bg-[#ffe1d9] ">
        <div className="mx-auto max-w-[1240px] pt-14">
          <SectionReveal enabled={showSectionReveal}>
          <div className="flex xs:flex-col-reverse xs:items-center md:items-start md:flex-row w-full bg-[#ffe1d9] overflow-hidden">
            <div className="   xs:mb-[0vh] xs:mt-10 md:mt-0  md:mb-0 xs:w-[95%] md:w-[40%] md:ml-0 xs:ml-[5%]">
              <img
                src={mm_apply_hero}
                className=" xs:mx-auto max-h-[671px] block "
                alt="Do I need experience? hero"
              />
            </div>
            <div className=" xs:mb-[0vh] xs:mt-0 md:mt-0  md:mb-0  xs:w-4/5 md:w-[58%] x1270:mx-[1.5rem] md:mr-[1.5rem]">
              
              <h2 className="module-subhead md:w-[80%] xs:w-[100%] mt-0">
                Do I need experience?
              </h2>
              <p className="module-bodycopy w-[95%]">
                No. Full training is provided, including facilitation skills, mentoring, reflective practice and event planning. Ongoing support is always available.<br/><br/>
                We understand this is emotionally sensitive work. Volunteers are supported through:<br/><br/>
                <ol className="list-disc pl-4">
                  <li className="pb-3">
                    Debrief after each session
                  </li>
                  <li className="pb-3">
                    Regular supervision with the Programme Lead
                  </li>
                  <li className="pb-3">
                    Reflective Practice & Emotional Wellbeing sessions
                  </li>
                  <li className="pb-0">
                    Access to an internal counsellor if needed
                  </li>
                  
                </ol>
                <br/>
              </p>
               <h2 className="module-subhead w-[100%] mt-0 ">
                What's the commitment?
              </h2>
              <p className="module-bodycopy w-[100%]">
                A minimum commitment of 12 months, including training.
              </p>
            </div>
          </div>
          </SectionReveal>
        </div>
      </div>

      {/* ---------------------------------------------------------------------------------------------------------------
      --------------------------------------- What's the commitment? & Find out more or apply --------------------------
       --------------------------------------------------------------------------------------------------------- */}
      <div className="bg-[#ffe1d9]">
        <div className="mx-auto max-w-[1240px] xs:pt-14 md:pt-14 pb-24">
          <SectionReveal enabled={showSectionReveal}>
          <div className="flex xs:flex-col md:flex-row xs:items-center md:items-start w-full bg-[#ffe1d9] overflow-hidden">
            <div className="module-left xs:mb-[0vh] xs:mt-[0vh] md:mt-0 md:mb-0 xs:w-4/5 md:w-[60%]">

           

              <h2 className="module-subheadL w-[100%] mt-0">
                Find out more or apply
              </h2>

              {/* Call-to-Action Box */}
              <div className="bg-[#DCB1FA] text-[#B24029] xs:mb-[0vh] xs:pr-4 xs:pl-7 md:px-0 pt-10 pb-[4rem] xs:mt-10 md:mt-10 md:mb-0 ctabox-width">
                <p className="ctabox-circle xs:w-[70%] md:w-[60%] mds:w-[70%] xs:mt-0 xs:mr-0 xs:ml-0 md:mt-0 md:mr-6 md:ml-7 font-sans antialiased tracking-[-0.01em] align-middle text-[#ffe1d9]">
                </p>
                <button className="ctabox-button2 text-[#B24029] border-[#B24029] font-medium">
                  <a
                    href="https://sistercirclelondon.typeform.com/to/PPj3HeQo"
                    rel="noreferrer"
                    target="_blank"
                  >
                    Become a Peer Support Volunteer
                  </a>
                </button>
                <p className="ctabox-circle xs:mt-0 xs:mr-0 xs:ml-0 md:mt-0 md:mr-6 md:ml-7 font-sans antialiased tracking-[-0.01em] align-middle text-[#B24029]">
                  Email: <span>
                    <a
                      className="underline"
                      href="mailto:volunteering@sistercircle.org.uk"
                      rel="noreferrer"
                      target="_blank"
                    >
                      volunteering@sistercircle.org.uk
                    </a>
                  </span>
                  <br></br>
                  <span>or call </span>
                  <span>
                    <a className="underline" href="tel:07496 531895">
                      07496 531895
                    </a>
                  </span>
                </p>
              </div>

            </div>
          </div>
          </SectionReveal>
        </div>
      </div>
   
      <Footer />
    </div>
  );
};

export default Volunteer;